import React from "react";

export function Checkbox({ isSelected, readOnly, onChange, children, disabled = false, id }) {
  return (
    <>
      <input readOnly={readOnly} type="checkbox" style={{ display: "none" }} />
      <label className="checkbox checkbox-lg checkbox-single">
        <input
          readOnly={readOnly}
          type="checkbox"
          checked={isSelected}
          onChange={onChange}
          disabled={disabled}
          id={id}
        />
        {children}
        <span />
      </label>
    </>
  );
}
